module.exports = __webpack_public_path__ + "img/C04MountedArcherS_ua.748d23f0.webp";